export const state = {
  azoliEntrepreneur: undefined,
  azoliEntrepreneurs: [],
}